export default __webpack_public_path__ + "static/media/s13a.b4813557.jpg";